import type { TutorQuizAttributes } from '@/server/models'

import { SQL, type SQLFragment } from '@/client/query'

import {
  type GroupBy,
  makeQueryModelV2,
  type QueryOrder,
  queryGroupByToSQL,
  queryOrderToSQL,
} from './common'

const TutorQuizQ = {
  ...makeQueryModelV2<TutorQuizAttributes>('tutor_quiz')([
    'id',
    'user_id',
    'details',
    'approved_at',
    'review_reason',
    'created_at',
    'deleted_at',
  ]),

  where: (
    {
      paranoid = true,
      approved,
      userId,
      groupBy = null,
      order = null,
    }: {
      paranoid?: boolean
      approved?: boolean
      userId?: number | null | SQLFragment<number>
      groupBy?: GroupBy | null
      order?: QueryOrder | null
    },
    customWhere: SQLFragment<unknown> | null = null
  ): SQLFragment<TutorQuizAttributes> => SQL`
        FROM ${TutorQuizQ}
        WHERE
            ${userId != null ? SQL`${TutorQuizQ.user_id} = ${userId} AND` : SQL``}
            ${
              approved != null
                ? SQL`${TutorQuizQ.approved_at} IS ${approved ? SQL`NOT` : SQL``} NULL AND`
                : SQL``
            }
            ${paranoid ? SQL`${TutorQuizQ.deleted_at} IS NULL AND` : SQL``}
            ${customWhere != null ? customWhere : SQL`TRUE`}
        ${queryGroupByToSQL(groupBy)}
        ${queryOrderToSQL(order)}
    `,
}

export default TutorQuizQ
